import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import Layout from '../components/Layout';

export default function TournamentAdminLayout() {
  const [status, setStatus] = useState('loading');
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { setStatus('unauthenticated'); return; }
      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const roles = userDoc.exists() ? (userDoc.data().roles || []) : [];
        setStatus(roles.includes('admin') || roles.includes('tournament_admin') ? 'admin' : 'denied');
      } catch {
        setStatus('denied');
      }
    });
    return unsub;
  }, []);

  if (status === 'loading') return (
    <Layout>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    </Layout>
  );

  if (status === 'unauthenticated') return <Navigate to="/" replace />;

  if (status === 'denied') return (
    <Layout>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h5" color="error">Access Denied</Typography>
        <Typography color="text.secondary">You need admin privileges to access this area.</Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>Back to Dashboard</Button>
      </Box>
    </Layout>
  );

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
